export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" data-testid="logo-mark">
    <rect width="48" height="48" rx="11" fill="#0B2B1D" stroke="rgba(212,163,115,0.45)" strokeWidth="1.5" />
    <path d="M11 33 L24 13 L37 33" fill="none" stroke="#FBF9F5" strokeWidth="4.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="24" cy="36.5" r="3.2" fill="#D4A373" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <a className={`brand ${light ? "brand-light" : ""}`} data-testid="brand-link" href="#home">
    <LogoMark />
    <span className="brand-text">
      JAY MAA SHERAWALI
      <small>TRANSPORT · PACKERS &amp; MOVERS · CAR CARRIERS</small>
    </span>
  </a>
);
